import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore'; // Removido getDoc, não é usado
import { db } from '../services/firebase'; // Certifique-se de que o 'db' está configurado corretamente

const CadastroRapido = () => {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [tipo, setTipo] = useState('');
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nome || !email || !whatsapp || !tipo) {
      setErro('Por favor, preencha todos os campos.');
      return;
    }

    if (!email.includes('@') || email.length < 5) {
      setErro('Digite um e-mail válido.');
      return;
    }

    if (!/^\d+$/.test(whatsapp)) {
      setErro('O WhatsApp deve conter apenas números.');
      return;
    }

    setErro('');
    setLoading(true);

    try {
      // 1. Cria ou loga o usuário no Firebase Auth
      const auth = getAuth();
      const senhaTemporaria = 'senhaFixa123'; // Pode trocar por geração dinâmica, se quiser

      try {
        await createUserWithEmailAndPassword(auth, email, senhaTemporaria);
        console.log('Usuário criado com sucesso no Firebase Auth.');
      } catch (error) {
        if (error.code === 'auth/email-already-in-use') {
          // Se já existe, tenta fazer login
          await signInWithEmailAndPassword(auth, email, senhaTemporaria);
          console.log('Usuário existente logado no Firebase Auth.');
        } else {
          throw error; // Lança outros erros de autenticação
        }
      }

      // 2. Salva os dados no Firestore
      await setDoc(
        doc(db, 'cadastros_rapidos', email),
        {
          nome,
          email,
          whatsapp,
          tipo,
          status: 'pendente',
          criadoEm: serverTimestamp(),
        },
        { merge: true } // Usa merge para não sobrescrever outros campos se o documento já existir
      );
      console.log('Dados salvos/atualizados no Firestore.');

      // 3. Redireciona para confirmar assinatura (com dados via state)
      navigate('/confirmar-assinatura', {
        state: {
          nomeCompleto: nome,
          email,
          telefone: whatsapp,
          tipoAssinatura: 'Assinatura Mensal', // Pode ser dinâmico, se houver outras opções
          valor: '19.90', // O valor é apenas para exibição aqui. O valor real vem do Stripe.
        },
      });
    } catch (error) {
      console.error('Erro ao cadastrar:', error);
      let mensagemErro =
        'Erro ao processar seu cadastro. Por favor, tente novamente.';
      if (error.message) {
        mensagemErro += ` Detalhes: ${error.message}`;
      }
      setErro(mensagemErro);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white rounded-lg p-6 w-full max-w-md text-elion-navy">
        <h2 className="text-2xl font-bold mb-4">Cadastro Rápido</h2>
        {erro && <p className="text-red-600 mb-2 font-medium">{erro}</p>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Seu Nome Completo"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded"
          />
          <input
            type="email"
            placeholder="Seu Melhor E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded"
          />
          <input
            type="text"
            placeholder="WhatsApp com DDD (somente números)"
            value={whatsapp}
            onChange={(e) => setWhatsapp(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded"
          />
          <select
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded"
          >
            <option value="">Selecione o tipo de conta</option>
            <option value="Corretor">Sou Corretor de Imóveis</option>
            <option value="Incorporadora">Sou Incorporadora</option>
          </select>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-2 rounded disabled:opacity-50"
          >
            {loading ? 'Enviando...' : 'Continuar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CadastroRapido;
